import { useEffect, useImperativeHandle, forwardRef } from 'react';
import { gsap } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import ScrollText from '@/components/UI/ScrollText';

type params = {
    textList: string[];
    currentList: string[];
    batteryNumber: string;
};
let TL1: GSAPTimeline | null;
const texts = '';
function Section3({ textList, currentList, batteryNumber }: params, ref: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();

    const { t } = useLang('delta_max_static');
    const animation = () => {
        if (!TL1) return;
        TL1.pause();
        TL1.seek(0);
        TL1.play();
    };
    const animationReverse = () => {
        if (!TL1) return;
        TL1.pause();
        TL1.seek(1);
        TL1.reverse();
    };
    useImperativeHandle(ref, () => ({
        animation,
        animationReverse,
    }));
    useEffect(() => {
        /**创建动画1时间线 */
        TL1 = gsap.timeline();
        TL1.pause();
        TL1.to('.note', {
            x: 0,
            duration: 0.5,
        });
        TL1.to(
            '.batteryText',
            {
                opacity: 1,
                duration: 0.5,
            },
            '-=0.5',
        );
        TL1.to('.batteryText', {
            left: 0,
            duration: 0.2,
        });

        return () => {
            TL1?.kill();
            TL1 = null;
        };
    }, []);
    return (
        <div className={`${css.section03} animation`}>
            <div className="canvas-wrapper"></div>
            <div className="text-container">
                <h2 className="mainTitle font-family-extrabold">
                    {(locale == 'sa' ? [...currentList].reverse() : currentList).map((currentText, index) => (
                        <ScrollText key={index} textList={textList} currentText={currentText} />
                    ))}
                    {t('batterywh')}
                </h2>
                <p className="text font-family-bold">{t('capacity_expand')}</p>
                <div className="note font-family-bold">
                    <span className="deltaMaxText">
                        {t.rich('capacity_notice_pc1', {
                            line1: (child) => <b className="purple">{child}</b>,
                        })}
                    </span>
                    <span className="batteryText">
                        &nbsp;
                        {t.rich('capacity_notice_pc2', {
                            line1: (child) => <b className="bule">{child}</b>,
                        })}
                        <ScrollText textList={textList} currentText={batteryNumber} />
                    </span>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(Section3);
